import React from 'react';
import { Link } from 'react-router-dom';

const Founder = () => {
  return (
    <div className="min-h-screen pt-32">
      {/* Hero */}
      <section className="py-20">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto">
            <h1 className="heading-1 mb-4">MEL MASRY</h1>
            <p className="heading-5 mb-4 text-secondary">Founder & Method Director</p>
            <p className="body-medium mb-12 text-secondary">PhD in Performing Arts</p>
            <p className="body-large">
              Coach, Educator, Actor, and Director of the GPS Method™
            </p>
          </div>
        </div>
      </section>

      {/* Bio Section */}
      <section className="py-20 bg-card">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto space-y-8">
            <div>
              <h2 className="heading-4 mb-4 text-primary">Background</h2>
              <p className="body-medium mb-4">
                I built the GPS Method™ because I needed a system that worked—one that addressed the psychological structure beneath performance, not just the surface technique.
              </p>
              <p className="body-medium text-secondary">
                After years of training and practice across multiple disciplines, including doctoral research in performing arts, I found that most approaches focused on what to do, not how to be internally structured to do it sustainably.
              </p>
            </div>

            <div>
              <h2 className="heading-4 mb-4 text-primary">The Method</h2>
              <p className="body-medium mb-4">
                The GPS Method is not derived from any single tradition. It is a synthesis—drawing from psychology, somatic work, and performance practice—designed to create a complete system for internal development.
              </p>
              <p className="body-medium text-secondary">
                It is rigorous, precise, and demands commitment. It is not for everyone, and that is intentional.
              </p>
            </div>

            <div>
              <h2 className="heading-4 mb-4 text-primary">Practice & Teaching</h2>
              <p className="body-medium mb-4">
                I personally guide the work at the GPS Coaching School. This is not a program I oversee from a distance—I am present in the formation of each practitioner.
              </p>
              <p className="body-medium text-secondary">
                My practice is international, with work based between the United Kingdom and Egypt. I work with professional actors, coaches in training, and serious practitioners across disciplines.
              </p>
            </div>

            <div>
              <h2 className="heading-4 mb-4 text-primary">Approach</h2>
              <p className="body-medium mb-4">
                I do not promise quick results. I do not guarantee industry outcomes. I do not use motivational language.
              </p>
              <p className="body-medium text-secondary">
                What I offer is a method—a clear, structured system for developing psychological readiness and internal stability. The rest is up to the practitioner.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Background */}
      <section className="py-20">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto">
            <h2 className="heading-2 mb-12">BACKGROUND</h2>
            <div className="space-y-6">
              <p className="body-medium">
                <span className="text-primary font-semibold">Academic Credentials:</span> PhD in Performing Arts. Extensive research in performance psychology and presence-based methodologies.
              </p>
              <p className="body-medium">
                <span className="text-primary font-semibold">Training:</span> Comprehensive study in performance psychology, somatic methods, and coaching methodologies across the UK, Europe, and Middle East.
              </p>
              <p className="body-medium">
                <span className="text-primary font-semibold">Professional Practice:</span> Actor, director, and coach working with professional performers and training institutions.
              </p>
              <p className="body-medium">
                <span className="text-primary font-semibold">Method Development:</span> Over a decade developing and refining the GPS Method™ through direct practice with professional actors and coaches.
              </p>
              <p className="body-medium">
                <span className="text-primary font-semibold">Current Role:</span> Method Director of the GPS Coaching School. Direct guidance of all training programs and advanced labs.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-card">
        <div className="container-custom text-center">
          <h2 className="heading-3 mb-8 text-secondary">STUDY WITH THE FOUNDER</h2>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/school" className="btn-primary inline-flex items-center">
              Join the School
            </Link>
            <Link to="/coaching" className="btn-secondary inline-flex items-center">
              Request Private Coaching
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Founder;